export function isOn(r, c, m) {
    return r >= 0 && c >= 0 && r < m.length && c < m[0].length && m[r][c];
}
export function isFinder(r, c, n) {
    return (r < 8 && c < 8) || (r < 8 && c >= n - 8) || (r >= n - 8 && c < 8);
}
